export default {
  SET_COMPLETE_REQUESTS: (state, payload) => (state.completeRequests = payload),
  SET_COMPLETE_REQUEST: (state, payload) => (state.completeRequest = payload)
}
